import {sub} from 'date-fns';

import {ASSETS_API} from 'src/config-global';

import {
  _id,
  _ages,
  _roles,
  _prices,
  _emails,
  _ratings,
  _nativeS,
  _nativeM,
  _nativeL,
  _percents,
  _booleans,
  _sentences,
  _lastNames,
  _fullNames,
  _tourNames,
  _jobTitles,
  _taskNames,
  _postTitles,
  _firstNames,
  _fullAddress,
  _companyNames,
  _productNames,
  _descriptions,
  _phoneNumbers,
  _department_name,
  _cost_center,
  _parent_department_name,
  _application_name,
  _app_support_cost,
  _app_service_cost,
  _app_license_cost,
  _app_ftes_cost,
  _app_hosting_onprem_cost,
  _app_license_renewal_date,
  _app_server_upgrade_cost,
  _fiscal_year,
  _opex_budget,
  _capex_budget,
  _network_cost,
  _it_staff_budget,
  _support_cost_type,
  _service_cost_type,
  _license_cost_type
} from './assets';
import {
  _app_costs_category,
  _app_costs_cost,
  _app_costs_type,
  _app_details_department,
  _app_details_name,
  _app_details_vendor,
  _departments_cost_center,
  _departments_department,
  _departments_faculty,
  _departments_faculty_name,
  _departments_location,
  _projects_contact_name,
  _projects_email,
  _projects_name,
  _projects_phone
} from './assets_App_Rationalization';

// ----------------------------------------------------------------------

export const _mock = {
  id: (index: number) => _id[index],
  time: (index: number) => sub(new Date(), {days: index, hours: index}),
  boolean: (index: number) => _booleans[index],
  role: (index: number) => _roles[index],
  // Text
  taskNames: (index: number) => _taskNames[index],
  postTitle: (index: number) => _postTitles[index],
  jobTitle: (index: number) => _jobTitles[index],
  tourName: (index: number) => _tourNames[index],
  productName: (index: number) => _productNames[index],
  sentence: (index: number) => _sentences[index],
  description: (index: number) => _descriptions[index],
  // Contact
  email: (index: number) => _emails[index],
  phoneNumber: (index: number) => _phoneNumbers[index],
  fullAddress: (index: number) => _fullAddress[index],
  // Name
  firstName: (index: number) => _firstNames[index],
  lastName: (index: number) => _lastNames[index],
  fullName: (index: number) => _fullNames[index],
  companyName: (index: number) => _companyNames[index],
  // Number
  number: {
    percent: (index: number) => _percents[index],
    rating: (index: number) => _ratings[index],
    age: (index: number) => _ages[index],
    price: (index: number) => _prices[index],
    nativeS: (index: number) => _nativeS[index],
    nativeM: (index: number) => _nativeM[index],
    nativeL: (index: number) => _nativeL[index]
  },
  // Image
  image: {
    cover: (index: number) =>
      `https://api-dev-minimal-v510.vercel.app/assets/images/cover/cover_${
        index + 1
      }.jpg`,
    // `${ASSETS_API}/assets/images/cover/cover_${index + 1}.jpg`,
    avatar: (index: number) =>
      `https://api-dev-minimal-v510.vercel.app/assets/images/avatar/avatar_${
        index + 1
      }.jpg`,
    // `${ASSETS_API}/assets/images/avatar/avatar_${index + 1}.jpg`,
    travel: (index: number) =>
      `${ASSETS_API}/assets/images/travel/travel_${index + 1}.jpg`,
    company: (index: number) =>
      `${ASSETS_API}/assets/images/company/company_${index + 1}.png`,
    product: (index: number) =>
      `${ASSETS_API}/assets/images/m_product/product_${index + 1}.jpg`,
    portrait: (index: number) =>
      `${ASSETS_API}/assets/images/portrait/portrait_${index + 1}.jpg`
  },
  // Departments
  department_name: (index: number) => _department_name[index],
  cost_center: (index: number) => _cost_center[index],
  parent_department_name: (index: number) => _parent_department_name[index],
  // Application Financials
  application_name: (index: number) => _application_name[index],
  support_cost: (index: number) => _app_support_cost[index],
  service_cost: (index: number) => _app_service_cost[index],
  license_cost: (index: number) => _app_license_cost[index],
  FTEs_cost: (index: number) => _app_ftes_cost[index],
  hosting_cost: (index: number) => _app_hosting_onprem_cost[index],
  license_renewal: (index: number) => _app_license_renewal_date[index],
  server_upgrades: (index: number) => _app_server_upgrade_cost[index],
  // Company Financials
  fiscal_year: (index: number) => _fiscal_year[index],
  opex_budget: (index: number) => _opex_budget[index],
  capex_budget: (index: number) => _capex_budget[index],
  network_cost: (index: number) => _network_cost[index],
  it_staff_budget: (index: number) => _it_staff_budget[index],
  support_cost_type: (index: number) => _support_cost_type[index],
  services_cost_type: (index: number) => _service_cost_type[index],
  license_cost_type: (index: number) => _license_cost_type[index],
  department_module: {
    faculty_name: (index: number) => _departments_faculty_name[index],
    location: (index: number) => _departments_location[index],
    department_name: (index: number) => _departments_department[index],
    cost_center: (index: number) => _departments_cost_center[index],
    faculty: (index: number) => _departments_faculty[index]
  },
  app_details: {
    name: (index: number) => _app_details_name[index],
    department: (index: number) => _app_details_department[index],
    vendor: (index: number) => _app_details_vendor[index]
  },
  app_costs: {
    category: (index: number) => _app_costs_category[index],
    cost: (index: number) => _app_costs_cost[index],
    type: (index: number) => _app_costs_type[index]
  },
  projects: {
    name: (index: number) => _projects_name[index],
    contact_name: (index: number) => _projects_contact_name[index],
    email: (index: number) => _projects_email[index],
    phone: (index: number) => _projects_phone[index]
  }
};
